import gql from "graphql-tag";

export default gql`
  query {
    subjects(filter: { status: public, alive_subject: SUBJECT_ALIVE }, sort: INDEX_ASC) {
      _id
      name
      description
      updatedAt
      photo
      alive_subject
      status
      index
      questionnaire
      teacher {
        _id
        username
        firstname
        lastname
        isTeacher
        avatar
        email
      }
    }
  }
`;
